// Func = limiting Scope for this file
(function(){

	if( document.querySelector( "#form_id-2243" ) ){

		let form = document.querySelector( "#form_id-2243" );

		form.appendChild( _access_token );

		let alterntative = document.createElement( "input" );
		alterntative.type = "hidden";
		alterntative.name = "_alternate_email_service";
		alterntative.value = "ems_revinate_sign_up";
		form.appendChild( alterntative );

	}
	

	function resizeWindow(){

	}
	function scrollDown(){
		let top = $(document).scrollTop();
		if (top > 0) {
			$('#header, #landing-header').addClass('scroll');
		} else {
			$('#header, #landing-header').removeClass('scroll');
		}

		if (top > $('.hero-container').outerHeight() - 59 ) {
			$('#header, #landing-header, .submenu-container').addClass('scroll--after-hero');
		} else {
			$('#header, #landing-header, .submenu-container').removeClass('scroll--after-hero');
		}
	}

	let video = document.getElementById("myVideoPlayer");
	function stopVideo(){
		video.pause();
		video.currentTime = 0;
	}

	$(document).ready(function () {

		$( "#booking-form" ).on( "submit", function(){

			var dates = $( "#pickup" ).val();

			if( dates != "" ){
				dates = dates.split( " - " );
				dataLayer.push({
					'event': 'bookingWidget',
					'checkin': dates[0],
					'checkout': dates[1]
				})
			}

		} )

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		}); 
		resizeWindow();

		// load full text label language
		//$selectedItemMenuLang = $('.language li a[attr-appr="'+$('.lang-selected').text().toLowerCase()+'"]');
		//if( $selectedItemMenuLang.length == 1 ) {
		//	$('.lang-selected').text($selectedItemMenuLang.text());
		//}

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown();
		});

		//$('.booking-holder').addClass('open');
		//$('.booking-holder').stop().animate({right:'120px'},{duration:600});
		//$('.open-booking-widget-inline-date').on('click', function(e){
		//	$("#adults").val(2);
		//	$("#child").val(0);
		//	$("#number_guest").text( "2 ADULTS" );
		//});

		//Booking Widget
		$('.booking-trig-js').click(function(event) {
			$('html').addClass('hide-overflow');
			$('.booking-holder').addClass('open');
			$('.booking-holder').stop().animate({right:'120px'},{duration:600});
			$('#content').click(function(e){
                e.preventDefault();
                $('html').removeClass('hide-overflow');
                $('.booking-holder').removeClass('open');
                $('.booking-holder').stop().animate({right:'-120vw'},{duration:600});
            }); 
		});

		$('.close-booking-js').click(function(event) {
			$('html').removeClass('hide-overflow');
			$('.booking-holder').removeClass('open');
			$('.booking-holder').stop().animate({right:'-120vw'},{duration:600});
		});


		$('.language li a').click(function(){
			// $('.lang-selected').html($(this).attr('attr-appr'));
			$('.lang-selected').html($(this).text());	// Full text
			$('.language').fadeOut();
		});
		$('.lang-selected').click(function(){
			if ($('.language').hasClass('active')){
				$('.language').fadeOut();
				$('.language').removeClass('active');
			} else {
				$('.language').fadeIn();
				$('.language').addClass('active');
			}
		});

		$('.video-link').click(function(){
			$('.video-popup').fadeIn();
			document.getElementById("myVideoPlayer").play();
		});
		$('.video-popup .close-icon').click(function(){
			$('.video-popup').fadeOut();
			stopVideo();
		});

		// Main Nav Dropdown
		//Open Navigation
		$('#menu-btn').click(function(e) {
			$('html').addClass('hide-overflow');
			$('.navigation').addClass('open');
			if($('#header').hasClass('scroll')) {
				$('.navigation').stop().animate({top:'0px'},{duration:600});
			} else {
				$('.navigation').stop().animate({top:'-22px'},{duration:600});
			}
			if($('.navigation ul li a').hasClass('.item-open')){
				$(".item-open").get(0).scrollIntoView(false);
			}
            $('#content').click(function(e){
                e.preventDefault();
                $('html').removeClass('hide-overflow');
                $('.navigation').removeClass('open');
                $('.navigation').stop().animate({top:'120vh'},{queue:false,duration:600});
				setTimeout(function(){
					$('.navigation').css({top:'-120vh'});
				}, 650);
				$(this).unbind();
            });
		});

		$('.close-menu').click(function(event) {
			event.preventDefault();
			$('html').removeClass('hide-overflow');
			$('.navigation').removeClass('open');
			$('.navigation').stop().animate({top:'120vh'},{queue:false,duration:600});
			setTimeout(function(){
				$('.navigation').css({top:'-120vh'});
			}, 650);
			$('#content').click(function(e){
				e.preventDefault();
				$('.navigation').stop();
				$(this).unbind();
			});
		});

		//SUBNAVIGATION

		// Open active sub-nav on load
		$('.navigation ul.submenu li .active').closest('.inner').addClass('open')
		$('.navigation ul.submenu li .active').parents().parents('li').addClass('item-open');
		$('.navigation ul.submenu li .active').closest('.sub-sub-menu').slideDown(300, function() {}).addClass('menu-open');

		//Toggle open/close on tap
		$('.navigation li a').off('click').on('click', function(event) {
			if ( $(this).parent().children(".sub-sub-menu").length > 0 ) {

				event.preventDefault();

				if ($(this).next().hasClass('menu-open')) {
					$(this).closest('.inner').removeClass('open');
					$('.navigation ul li').removeClass('item-open');
					$(this).parent().addClass('item-open');
					$(this).next().slideUp(300, function(){
						if($('.navigation ul li a').hasClass('active')){
							$(".item-open").get(0).scrollIntoView(false);
						}
					}).removeClass('menu-open');
				} else {
					$(this).closest('.inner').addClass('open');
					$('.navigation ul li').removeClass('item-open');
					$(this).parent().addClass('item-open');
					$('.sub-sub-menu.menu-open').slideUp(300).removeClass('menu-open');
					$(this).next().addClass('menu-open').slideDown(300, function(){
						if($('.navigation ul li a').hasClass('active')){
							$(".item-open").get(0).scrollIntoView(false);
						}
					});
				}
			}
		});

		//$("#primary-nav li").hover(function(){
		//	$(this).addClass("hover");
		//	$('ul.submenu',this).fadeIn(200);
		//}, function(){
		//	$(this).removeClass("hover");
		//	$('ul.submenu',this).fadeOut(200);
		//});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});



		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

}());